"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../util/GlobalScript.js");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("../buttons/Button"));

var _DetailsTooltip = _interopRequireWildcard(require("../tooltips/DetailsTooltip"));

var _popsOver = _interopRequireDefault(require("../../util/behaviors/popsOver"));

var _ButtonGroup = _interopRequireDefault(require("../layout/ButtonGroup"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @class ConfirmTooltip
 * @desc ConfirmTooltip implements tooltip used to confirm or deny the canceling of an action.
 *
 * @param {string} buttonLabel
 *      text for the button label
 * @param {string} buttonType
 *      css class to set the type of button(primary, secondary, danger)
 * @param {string} cancelText
 *      text of the cancel A tag
 * @param {bool} [closeOnConfirm=false]
 *      when true, triggers onToggle when onConfirm is triggered.
 * @param {string} [data-id]
 *     The data-id of the component.
 * @param {bool} disableSave
 *      boolean to turn enable or disable the button.
 * @param {node} label
 *     The text of the link.
 * @param {boolean} loading
 *     While true, loading animation will be shown.
 * @param {boolean} open
 *     The prop that controls whether the tooltip is visible or not
 * @param {ConfirmTooltip~onCancel} onCancel
 *     The callback triggered when the cancel button is pressed.
 * @param {ConfirmTooltip~onConfirm} onDelete
 *     The callback triggered when the delete button is pressed.
 * @param {ConfirmTooltip~onToggle}
 *      the callback to open and close the modal.
 * @param {string} [positionClassName]
 *     CSS classes to set on the top-level HTML container. Used to manage tooltip callout positioning.
 *      When using multiple positions like "top left" or "bottom right" do not use dashes as it will not work.
 * @param {DetailsTooltip.tooltipPlacements} [placement]
 *     How the tooltip is placed off of its trigger.
 * @param {string} title
 *     The title of the ConfirmTooltip tooltip.
 * @param {string} type
 *     The Style/type of button
 *
 * @example
 *     <ConfirmTooltip
 *          placement="bottom right"
 *          label="Confirm Delete Cancel"
 *          title="Confirm Delete Cancel"
 *          onToggle={this._handleToggle}
 *          open={this.state.open}
 *          onConfirm={this._handleConfirm}
 *          onDelete={this._handleConfirm}
 *          onCancel={this._handleCancel}
 *          buttonLabel="Confirm"
 *          cancelText="Cancel"
 *          >
 *          {markup}
 *     </ConfirmTooltip>
 */
var ConfirmTooltipBase = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ConfirmTooltipBase, _Component);

  var _super = _createSuper(ConfirmTooltipBase);

  function ConfirmTooltipBase() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, ConfirmTooltipBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleConfirm", function (e) {
      if (_this.props.onConfirm) {
        _this.props.onConfirm(e);
      }

      if (_this.props.closeOnConfirm) {
        _this.props.onToggle(e);
      }
    });
    return _this;
  }

  (0, _createClass2.default)(ConfirmTooltipBase, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_DetailsTooltip.DetailsTooltipStateless, (0, _extends2.default)({}, this.props, {
        "data-id": this.props["data-id"]
      }), this.props.children, /*#__PURE__*/_react.default.createElement(_ButtonGroup.default, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
        "data-id": "".concat(this.props["data-id"], "-button"),
        label: this.props.buttonLabel || "Confirm",
        type: this.props.buttonType,
        onClick: this._handleConfirm,
        disabled: this.props.disableSave,
        loading: this.props.loading
      }), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("a", {
        className: "cancel",
        label: "Cancel",
        "data-id": "".concat(this.props["data-id"], "-cancel"),
        onClick: this.props.onCancel || this.props.onClose
      }, this.props.cancelText || "Cancel")));
    }
  }]);
  return ConfirmTooltipBase;
}(_react.Component);

(0, _defineProperty2.default)(ConfirmTooltipBase, "propTypes", {
  buttonLabel: _propTypes.default.string,
  buttonType: _propTypes.default.string,
  className: _propTypes.default.string,
  cancelText: _propTypes.default.string,
  closeOnConfirm: _propTypes.default.bool,
  "data-id": _propTypes.default.string,
  disableSave: _propTypes.default.bool,
  label: _propTypes.default.node,
  loading: _propTypes.default.bool,
  onCancel: _propTypes.default.func,
  onConfirm: _propTypes.default.func,
  open: _propTypes.default.bool,
  onToggle: _propTypes.default.func,
  placement: _propTypes.default.oneOf((0, _values.default)(_DetailsTooltip.default.tooltipPlacements))
});
(0, _defineProperty2.default)(ConfirmTooltipBase, "defaultProps", {
  "data-id": "confirm-tooltip",
  closeOnConfirm: false
});
var ConfirmTooltip = (0, _popsOver.default)(ConfirmTooltipBase);
var _default = ConfirmTooltip;
exports.default = _default;
module.exports = exports["default"];